export default __webpack_public_path__ + "static/media/68_desktop.005a81ce.jpg";